import React from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import css from './OrderRecipe.css'

const OrderRecipe = ({ recipeImage, recipeTitle, portions }) => (
  <div className={css.recipe} data-testing="orderRecipe">
    {recipeImage ? (
      <img className={css.image} src={recipeImage} alt={recipeTitle} />
    ) : (
      <div className={classNames(css.image, css.blankImage)} />
    )}
    <div className={css.recipeDetails}>
      <div className={css.recipeTitle}>{recipeTitle}</div>
      <div>{portions}</div>
    </div>
  </div>
)

OrderRecipe.propTypes = {
  recipeImage: PropTypes.string,
  recipeTitle: PropTypes.string,
  portions: PropTypes.string,
}

OrderRecipe.defaultProps = {
  recipeImage: '',
  recipeTitle: '',
  portions: '',
}

export default OrderRecipe
